import { Link } from 'react-router-dom';
import styles from './GuideOutro.module.css';

// Closes the guide: a short set of habits that get the most out of RepBuddy, a plain note
// on data isolation, and where to get help.
const HABITS = [
  {
    title: 'Invest in your Seller Profile first',
    body: 'It is the input every hunt reads from. An hour spent making it precise saves you from correcting results on every search after.',
  },
  {
    title: 'Ask in plain language, then refine',
    body: 'Start with a natural sentence. If the results drift, add one constraint at a time rather than rewriting the whole request.',
  },
  {
    title: 'Trust the checks',
    body: 'A contact that reaches your list is deliverable and currently employed. A contact that fails never arrives and never costs you a credit. Let the filters do their job.',
  },
  {
    title: 'Read the confidence tiers',
    body: 'On enriched data, verified is confirmed, researched is assembled from multiple sources, and partial is flagged as best-available. Send on the confirmed, double-check the rest.',
  },
  {
    title: 'Organize by session',
    body: 'Use a new chat session per campaign or segment. Your history is saved to the cloud and waiting on any device.',
  },
  {
    title: 'Verify before you send',
    body: 'Run an old list through verification before a campaign. Protecting your sender reputation costs far less than rebuilding it.',
  },
];

export default function GuideOutro() {
  return (
    <section id="best-practices" className={styles.section}>
      <div className={styles.inner}>
        <span className={styles.eyebrow}>Best practices</span>
        <h2 className={styles.heading}>Getting the best results</h2>
        <p className={styles.lede}>
          A few habits separate a good run from a great one. None of them take extra time once
          they are second nature.
        </p>

        <div className={styles.grid}>
          {HABITS.map((h) => (
            <div key={h.title} className={styles.card}>
              <h3 className={styles.cardTitle}>{h.title}</h3>
              <p className={styles.cardText}>{h.body}</p>
            </div>
          ))}
        </div>

        <div className={styles.privacy}>
          <h3 className={styles.privacyTitle}>Your data stays yours</h3>
          <p className={styles.privacyText}>
            Every account is isolated at the database level with row-level security. Your
            contacts, hunts, and lists are never shared with or visible to another customer.
            Signing out clears local data, and switching accounts on the same browser resets
            to the new user, so nothing crosses over.
          </p>
        </div>

        <div className={styles.help}>
          <span className={styles.helpText}>Still have a question this page did not answer?</span>
          <div className={styles.helpLinks}>
            <Link className={styles.helpLink} to="/faq">Read the FAQ</Link>
            <a className={styles.helpLink} href="mailto:support@repbuddy.io">support@repbuddy.io</a>
          </div>
          <span className={styles.helpMuted}>We reply within one business day.</span>
        </div>
      </div>
    </section>
  );
}
